import * as React from 'react'
import type { SVGProps } from 'react'
const SvgReddit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.9604 3.481c0 1.3702-1.1108 2.481-2.481 2.481-1.1734 0-2.1566-.8147-2.4147-1.9092-1.4394.1977-2.5515 1.4354-2.5515 2.9282l-.0002.0094c2.219.0823 4.2477.7074 5.8549 1.7019a3.486 3.486 0 0 1 2.1307-.7228C22.4324 7.9695 24 9.5372 24 11.471c0 1.3945-.8153 2.5987-1.9953 3.1618-.1097 4.0691-4.5422 7.3424-9.994 7.3424-5.4472 0-9.8768-3.2678-9.9937-7.3322C.8253 14.0844 0 12.8741 0 11.471c0-1.9338 1.5676-3.5015 3.5014-3.5015.806 0 1.5485.2724 2.1403.7301 1.592-.988 3.599-1.6132 5.7958-1.7064l-.0003-.0108c0-2.0815 1.5864-3.8002 3.6135-4.0102C15.2854 1.846 16.2836 1 17.4794 1c1.3702 0 2.481 1.1108 2.481 2.481M7.1713 15.4805c.9815 0 1.8243-.4582 1.8826-1.7188v.0014c.0583-1.2606-.69-2.313-1.6716-2.313s-1.8243.8247-1.8826 2.0853.69 1.9451 1.6716 1.9451m9.6733 0c-.9816 0-1.8243-.4582-1.8826-1.7188v.0014c-.0583-1.2606.69-2.313 1.6715-2.313s1.8243.8247 1.8826 2.0853-.69 1.9451-1.6715 1.9451m-4.8378.9802c-1.2162 0-2.3824.0597-3.4597.1694-.1847.018-.3013.2096-.2291.3804.6039 1.4425 2.0283 2.456 3.6888 2.456s3.0863-1.0135 3.6889-2.456c.0721-.1708-.0459-.3624-.2291-.3804-1.0788-.1097-2.2436-.1694-3.4598-.1694"
      clipRule="evenodd"
      style={{
        fill: 'currentColor',
        fillOpacity: 1,
      }}
    />
  </svg>
)
export default SvgReddit
